import { css } from 'styled-components';
import { themeGet } from 'modules/tetrisTheme';
export function getStylesBySelected() {
    return css `
    background-color: ${themeGet('colors.primary.50')};
    color: ${themeGet('colors.text.300')};

    &:disabled {
      background-color: ${themeGet('colors.disabled.100')};
      color: ${themeGet('colors.disabled.200')};
    }
  `;
}
